var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"background-color":"#ffffff"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('SelfAssessment')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('h3',{staticClass:"timelinetitle"},[_vm._v("Overview of your suppliers ESG score over time and displayedon category")]),_c('ESGscoretimeline')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }